import * as _ from 'underscore';
import { ContentDefinitions } from './models/ContentDefinitions';
import { ContentType, OmniboxConfiguration } from "./models/Types";

export const defaultOmniboxConfiguration: OmniboxConfiguration = {
    apiHost: '',
    showOwnerLinks: false,
    contentTypesForQuickLinks: [ContentType.view, ContentType.workbook, ContentType.metric, ContentType.collection, ContentType.unifieddatasource],
    requiredContentTypes: Object.keys(ContentDefinitions).map(item => item as ContentType),
    hostComponent: 'VPC',
    pastQueryMaxCount: 4,
    contentSuggestionMaxCount: 6,
    emptyStateContentSuggestionMaxCount: 6
};

export class OmniboxConfigurationService {
    private isinitialized = false;

    public configuration: OmniboxConfiguration
    public static instance = new OmniboxConfigurationService();

    constructor() {
        this.reset();
    }

    public initialize(configuration: OmniboxConfiguration) {
        if (!this.isinitialized) {
            this.configuration = _.extend({}, defaultOmniboxConfiguration, configuration);
            this.isinitialized = true;
        }
    }

    public reset() {
        this.isinitialized = false;
        this.configuration = _.extend({}, defaultOmniboxConfiguration);
    }
}